import { ComponentPropsWithoutRef } from 'react';

import { SpinnerIcon } from '@sternum/web/icons';

import { Container } from './AppLoader.styles';

export interface AppLoaderProps extends ComponentPropsWithoutRef<'div'> {
  size?: number;
}

export function AppLoader({ size = 30, ...props }: AppLoaderProps) {
  return (
    <Container role="presentation" aria-label="app loading" {...props}>
      <SpinnerIcon width={size} height={size} />
    </Container>
  );
}
